// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, signOut} from "firebase/auth";
import { getFirestore, collection, getDocs, setDoc, doc,getDocFromCache,addDoc,getDoc, updateDoc } from 'firebase/firestore';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCljLQU0x97cepWowoIEUJp9nj-ZNQyNxQ",
  authDomain: "mbh4-f3dc5.firebaseapp.com",
  projectId: "mbh4-f3dc5",
  storageBucket: "mbh4-f3dc5.firebasestorage.app",
  messagingSenderId: "939314907650",
  appId: "1:939314907650:web:b05f769f8e5455c9bbb51b"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);


export {
    auth,createUserWithEmailAndPassword, signInWithEmailAndPassword, onAuthStateChanged, signOut,db,collection,getDocs,setDoc,doc,getDocFromCache, addDoc,getDoc,updateDoc
}